
import HeaderBar from '../components/HeaderBar.vue'

export default {
  name: 'SimulatedLayout',
  components: {
    HeaderBar,
  },
  middleware: 'authentication',
  data() {
    return {
      img: '/img/standardUser.svg',
    }
  },
  computed: {
    user() {
      return this.$store.getters['credential/user']
    },
  },
  async created() {
    const response = await this.$axios.get('/api/v1/academic/customer')
    if (response.data.image) {
      const newImageURL = response.data.image
      this.$store.commit('credential/updateImage', newImageURL)
      this.img = newImageURL
    } else {
      this.$store.commit('credential/updateImage', this.img)
    }
  },
}
